import { ITilesMap } from '../../types/map';

export function getRequiredTiles(loadedTiles: ITilesMap, visibleTiles: YMaps.TTileNumber[]): YMaps.TTileNumber[] {
  return visibleTiles.filter(visibleTile => {
    const visibleTileHash = visibleTile.join();

    return !loadedTiles[visibleTileHash];
  });
}
